import { render, staticRenderFns } from "./monthCard-batch-edit.vue?vue&type=template&id=3c953c33&scoped=true&"
import script from "./monthCard-batch-edit.vue?vue&type=script&lang=js&"
export * from "./monthCard-batch-edit.vue?vue&type=script&lang=js&"
import style0 from "./monthCard-batch-edit.vue?vue&type=style&index=0&id=3c953c33&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c953c33",
  null
  
)

export default component.exports